import { createComponent } from "@front/utils/alpine";
import { GoogleMapsAPI } from  '../services/gmaps';
import { GooglePlaceStore } from '../services/gplace';
import { buildFormData } from "@front/utils";
import prestashop from 'prestashop';

type TStore = {
    idStore: string;
    placeId: string | undefined;
    lastUpdate: number;
};
type TPlaceResults = google.maps.places.PlaceResult[];
type TPlaceOpeningHoursPeriod = google.maps.places.PlaceOpeningHoursPeriod;
type TPlaceOpeningHoursPeriodArray = {
    [day:string] : TPlaceOpeningHoursPeriod[]
};

function toggleBodyOverflow (force: boolean) {
    document.body.classList.toggle('md:overflow-y-hidden', force);
}

function minTwoDigits(n: string|number) {
  return (n < 10 ? '0' : '') + n;
}

function parseHours(gstore: GooglePlaceStore) {
    let hourByDay = <TPlaceOpeningHoursPeriodArray>{};
    if(gstore && gstore.schedule) {
        gstore.schedule.forEach((element) => {
            let day = element.open?.day;
            if(day >= 0) {
                if(day === 0) {
                    day = 7;
                }
                if(typeof hourByDay[day] == 'undefined')
                    hourByDay[day] = <TPlaceOpeningHoursPeriod[]>[];

                hourByDay[day].push(element);
            }
        });
    }
    return hourByDay;
}

async function updateStoreHours(id: number, placeId: string, gstore: GooglePlaceStore | undefined) {

    let html = '';
    let stringHours = [];
    if(gstore && gstore.schedule) {
        let hourByDay = parseHours(gstore);
        for (let day = 1; day < 8; day++) {
            if(typeof hourByDay[day] == 'undefined') {
                stringHours.push('');
                continue;
            }
            const hours = hourByDay[day];
            html = '';
            hours.forEach((item:TPlaceOpeningHoursPeriod) => {
                if(item.open && item.close)
                    html += `${minTwoDigits(item.open.hours)}:${minTwoDigits(item.open.minutes)} - ${minTwoDigits(item.close.hours)}:${minTwoDigits(item.close.minutes)} | `;
            });
            html = html.substring(0, html.length - 3); // remove last separator
            stringHours.push(html);
        }
    }

    const opts = {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
        },
        body: buildFormData({
            ajax: '1',
            action: 'updateStoreHours',
            id_store: id,
            place_id: placeId,
            hours: JSON.stringify(stringHours),
        }),
    };

    const response = await fetch(prestashop.urls.pages.stores, opts);
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }
}

async function getLastUpdateTimeStores() {
    const opts = {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
        },
        body: buildFormData({
            ajax: '1',
            action: 'getLastUpdateStores',
        }),
    };

    const response = await fetch(prestashop.urls.pages.stores, opts);
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }

    const json = await response.json();
    return json;
}

export default createComponent(() => ({

    isOpened: false,
    stores: {} as { [key: string]: boolean },
    storesInfos: {} as { [key: number]: TStore },


    open (id: number) {
        this.isOpened = true;
        this.stores[id] = true;
    },

    close () {
        this.isOpened = false;

        Object.keys(this.stores).forEach(key => {
            this.stores[key] = false;
        });
    },

    setupStore (id: number) {
        this.stores[id] = false;
    },


    async setupStoreHours (id: number, placeId: string | undefined, lastUpdate: number) {

        const nbHours = 2; // hours before update

        if(!placeId)
            return;

        if(
            Date.now() - (lastUpdate * 1000) > (60 * 60 * 1000 * nbHours)
        ) {
            // last update > nbHours hour
            GoogleMapsAPI.load();
            await GoogleMapsAPI.ready;
            const gstore = await GooglePlaceStore.find(placeId);
            await updateStoreHours(id, placeId, gstore);
        }
    },

    async updateStoresIfNeeded () {
        this.storesInfos = await getLastUpdateTimeStores();
        if(!this.storesInfos)
            return;

        for (const idStore in this.storesInfos) {
            if (Object.prototype.hasOwnProperty.call(this.storesInfos, idStore)) {
                const store = this.storesInfos[idStore];
                this.setupStoreHours(store.idStore, store.placeId, store.lastUpdate);
            }
        }
    },

    async init () {
        await this.updateStoresIfNeeded();
        toggleBodyOverflow(this.isOpened);
        this.$watch('isOpened', toggleBodyOverflow);
    },

}));
